import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http/http.service';
import { Path } from 'src/app/utils/constant/paths';

@Injectable({
  providedIn: 'root'
})
export class WurmService {

  constructor(
    private http: HttpService,
  ) { }

  getList(data?: any) {
    return this.http.post(Path.WURM.GET_LIST, data);
  }

  getDetail(params?: any) {
    return this.http.get(Path.WURM.GET_DETAIL, params);
  }
    
  insert(data?: any) {
    return this.http.post(Path.WURM.INSERT, data);
  }

  genericMaintenanceDownload(data?: any) {
    return this.http.post(Path.DOWNLOAD.DOWNLOAD_WEB_USER_RECIPIENT_MAPPING_MAINTENACE, data);
  }
}